<style lang="scss" scoped>
@import "/src/styles/css/_variables.css";
@import "./bottom-sheet.scss";
</style>

<template>
  <div :class="`slk-g-bottom-sheet ${drawerHeight} ${attached ? 'attached' : ''} ${isVisible ? 'show' : ''}`">
    <header v-if="!noHeader">
      <div class="_close">
        <svg class="feather" @click="closeBottomSheet">
          <use href="/imgs/storybook/feather-sprite.svg#x" />
        </svg>
      </div>
      <div class="_title">{{ title }}</div>
    </header>
    <section v-if="!noHeader">
      <slot name="content"></slot>
    </section>

    <div class="content-only" v-if="noHeader">
      <slot name="content"> </slot>
    </div>
  </div>
</template>

<script>
// import Checkbox from "../checkbox/checkboxView.vue";

export default {
  name: "BottomSheet",
  components: {},
  props: {
    title: { type: String, default: "Header" },
    drawerHeight: { type: String, default: "default" },
    attached: { type: Boolean, default: false },
    isVisible: { type: Boolean, default: false },
    noHeader: { type: Boolean, default: false },
  },
  methods: {
    closeBottomSheet() {
      this.$emit("close");
    },
  },
};
</script>
